import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=248da924"
import script from "./VInput.vue?vue&type=script&lang=ts"
export * from "./VInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports